import {
  canBeOptional,
  checkIsMarkedOptional,
  getFeatureId,
  checkIsFeatureSelected,
} from '../../services';
import { Box, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { isFeatureVisible } from '../../services/ClaimsHelper';
import type { IOptionalControlProps } from '../../../types';

export const OptionalControl = ({
  featureFamily,
  onOptionalChange,
  option,
  disabled,
  featureFlag,
}: IOptionalControlProps) => {
  const { t } = useTranslation();

  // To identify feature belongs to which family concatinate familyid and feature id with . if featureFamily type is multiselect/select
  const featureOrOptionId = getFeatureId(option?.value, featureFamily);

  function handleChange(e: { target: { checked: boolean } }) {
    if (onOptionalChange) {
      onOptionalChange(featureOrOptionId, e.target.checked, featureFamily);
    }
  }

  if (!isFeatureVisible(featureFlag)) {
    return null;
  }

  const isfeatureOrOptionOptional =
    canBeOptional(featureFamily.properties ?? []) || canBeOptional(option?.properties ?? []);

  if (!isfeatureOrOptionOptional) {
    return <Box className="hyphen"> - </Box>;
  }

  const isChecked = () => {
    return (
      checkIsMarkedOptional(featureOrOptionId, featureFamily) &&
      !checkIsFeatureSelected(featureOrOptionId, featureFamily)
    );
  };

  const isDisabled = () => {
    return disabled || checkIsFeatureSelected(featureOrOptionId, featureFamily);
  };

  return (
    <>
      <Box sx={{ display: { xs: 'inline', sm: 'none' } }}>{t('labels.optional')}:&nbsp;</Box>
      <Checkbox
        checked={isChecked()}
        onChange={handleChange}
        disabled={isDisabled()}
        className="paddingTopBottom"
      />
    </>
  );
};
